export const APP_WEBHOOK_GET_REQUEST = "APP_WEBHOOK_GET_REQUEST";
export const APP_WEBHOOK_GET_SUCCESS = "APP_WEBHOOK_GET_SUCCESS";
export const APP_WEBHOOK_GET_FAIL = "APP_WEBHOOK_GET_FAIL";

export const APP_WEBHOOK_UPDATE_REQUEST = "APP_WEBHOOK_UPDATE_REQUEST";
export const APP_WEBHOOK_UPDATE_SUCCESS = "APP_WEBHOOK_UPDATE_SUCCESS";
export const APP_WEBHOOK_UPDATE_FAIL = "APP_WEBHOOK_UPDATE_FAIL";
export const APP_WEBHOOK_UPDATE_RESET = "APP_WEBHOOK_UPDATE_RESET";

export const APP_WEBHOOK_ROTATE_REQUEST = "APP_WEBHOOK_ROTATE_REQUEST";
export const APP_WEBHOOK_ROTATE_SUCCESS = "APP_WEBHOOK_ROTATE_SUCCESS";
export const APP_WEBHOOK_ROTATE_FAIL = "APP_WEBHOOK_ROTATE_FAIL";
export const APP_WEBHOOK_ROTATE_RESET = "APP_WEBHOOK_ROTATE_RESET";

export const APP_WEBHOOK_DELIVERIES_REQUEST = "APP_WEBHOOK_DELIVERIES_REQUEST";
export const APP_WEBHOOK_DELIVERIES_SUCCESS = "APP_WEBHOOK_DELIVERIES_SUCCESS";
export const APP_WEBHOOK_DELIVERIES_FAIL = "APP_WEBHOOK_DELIVERIES_FAIL";
